module.exports = __webpack_public_path__ + "img/o_12.39ea469b.png";